import { Box, Flex, Select, Text } from "@chakra-ui/react";
import axios from "axios";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { getRole } from "utils/functions";
import { api } from "../../config";

const ViewPaymentProfile: React.FC = () => {
  const role = getRole()

  const [stripePaymentProfiles, setStripePaymentProfiles] = React.useState<
    { id: number; name: string; isactive: boolean }[]
  >([])

  const history = useHistory()

  const fetchStripePaymentProfiles = async () => {
    try {
      const { data } = await axios.get(`${api}/stripeprofiles/list-profiles`, {
        withCredentials: true,
      })

      setStripePaymentProfiles(data)
    } catch (err: any) {
      console.log(err)
    }
  }

  const setDefaultPaymentProfile = async (profileId: string) => {
    try {
      await axios.put(
        `${api}/stripeprofiles/set-default/${profileId}`,
        {},
        {
          withCredentials: true,
        },
      )

      fetchStripePaymentProfiles()
    } catch (err: any) {
      console.log(err)
    }
  }

  React.useEffect(() => {
    role === "Client" && fetchStripePaymentProfiles()
  }, [role])

  return (
    <>
      <div>
        <Flex gridGap={4}>
          <Box bg="gray.200" p="3" mt="2" rounded={10}>
            <Text>Default Payment Profile</Text>

            <Select
              value={stripePaymentProfiles.find((p) => p.isactive)?.id || ""}
              onChange={(e) => setDefaultPaymentProfile(e.target.value)}
            >
              {stripePaymentProfiles.map((profile) => (
                <option key={profile.id} value={profile.id}>
                  {profile.name}
                </option>
              ))}
            </Select>
          </Box>
        </Flex>
      </div>
    </>
  )
}

export default ViewPaymentProfile